import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { globals } from '../globals';
import './Collections.css';
import { useNavigate } from 'react-router-dom';

function Collections() {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCollections = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${globals.homepageUrl}/php/get-collections.php`);
        if (res.data.success) {
          setCollections(res.data.collections);
        } else {
          setError('Errore nel recupero delle collections.');
        }
      } catch (err) {
        setError('Errore di rete o server.');
      } finally {
        setLoading(false);
      }
    };

    fetchCollections();
  }, []);

  const handleCollectionClick = (collection) => {
    navigate(`/collection/${collection.id}`);
  };

  return (
    <div className="collections-container">
      {loading && <p>Caricamento delle collections...</p>}
      {error && <p className="error">{error}</p>}

      <div className="collections-list">
        {collections.length === 0 && !loading && <p>Nessuna collection salvata.</p>}
        {collections.map((collection) => (
          <div
            key={collection.id}
            className="collections-thumbnail"
            onClick={() => handleCollectionClick(collection)}
          >
            {collection.featured_image ? (
              <img
                src={`${globals.homepageUrl}/${collection.featured_image.replace(/^\/+/, '')}`}
                alt={collection.label}
                className="collections-thumbnail-image"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                  e.currentTarget.nextSibling.style.display = 'block';
                }}
              />
            ) : null}
            <div
              className="collections-thumbnail-placeholder"
              style={{ display: collection.featured_image ? 'none' : 'block' }}
            />

            <div className="search-terms">
              {collection.label.toUpperCase()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Collections;